import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import TrustBadge from "@/components/TrustBadge";

export default function ProductCard({ product }) {
  const img = product.images?.[0] || "https://placehold.co/600x800/000/fff?text=OUTLAW-D";
  const isThrift = !product.is_custom;
  const soldOut = (product.stock ?? 0) <= 0;
  const { has, toggle } = useWishlist() || {};
  const wished = has ? has(product.product_id) : false;
  const onHeart = (e) => { e.preventDefault(); e.stopPropagation(); toggle?.(product); };
  return (
    <Link
      to={`/product/${product.product_id}`}
      data-testid={`product-card-${product.product_id}`}
      className={`block bg-white border-2 border-black brutal-shadow hover-nudge relative overflow-hidden group ${soldOut ? "opacity-95" : ""}`}
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-[#F4F4F0]">
        <img
          src={img}
          alt={product.name}
          className={`w-full h-full object-cover transition-[filter] duration-300 ${soldOut ? "grayscale contrast-90" : "group-hover:grayscale"}`}
        />
        <button
          type="button"
          onClick={onHeart}
          data-testid={`wishlist-toggle-${product.product_id}`}
          aria-label={wished ? "Remove from wishlist" : "Save to wishlist"}
          className={`absolute bottom-3 right-3 w-9 h-9 flex items-center justify-center border-2 border-black rounded-full ${wished ? "bg-[#FF007F] text-white" : "bg-white text-black"} hover-nudge`}
        >
          <Heart className={`w-4 h-4 ${wished ? "fill-current" : ""}`} />
        </button>

        {isThrift && !soldOut && (
          <span className="sticker orange absolute top-3 left-3 rotate-[-4deg]" data-testid="thrift-badge">THRIFTED</span>
        )}
        {product.tags?.includes("1 of 1") && !soldOut && (
          <span className="sticker absolute top-3 right-3 rotate-[3deg]">1 OF 1</span>
        )}
        {!product.is_custom && product.seller_id && product.bargain_enabled !== false && !soldOut && (
          <span
            data-testid="bargain-badge"
            title="Open to offers"
            className="absolute bottom-3 left-3 inline-flex items-center gap-1 border-2 border-black bg-[#D4FF00] text-black px-2 py-[3px] font-mono-b font-bold uppercase text-[10px] brutal-shadow-sm"
          >
            💬 OPEN TO OFFERS
          </span>
        )}

        {soldOut && (
          <>
            {/* Diagonal SOLD stamp */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-testid="sold-stamp">
              <div className="bg-black text-[#FF007F] font-display text-5xl md:text-6xl px-6 py-2 border-4 border-[#FF007F] rotate-[-12deg] tracking-wider shadow-[6px_6px_0_0_#FF007F]">
                SOLD
              </div>
            </div>
            {isThrift && (
              <span className="sticker orange absolute top-3 left-3 rotate-[-4deg]" data-testid="thrift-badge-sold">THRIFTED · GONE</span>
            )}
          </>
        )}
      </div>
      <div className="p-4 border-t-2 border-black">
        <div className="flex items-start justify-between gap-2">
          <h3 className={`font-display text-xl leading-tight ${soldOut ? "line-through decoration-[3px] decoration-[#FF007F]" : ""}`}>{product.name}</h3>
          <span className={`font-mono-b font-bold text-lg whitespace-nowrap ${soldOut ? "text-black/40 line-through" : ""}`}>₹{product.price}</span>
        </div>
        <p className="text-xs uppercase font-mono-b text-black/60 mt-1">
          {product.category.replace("-", " ")} {soldOut && <span className="text-[#FF007F] font-bold">· SOLD</span>}
        </p>
        {(product.seller_badges?.length > 0 || !product.seller_id) && (
          <div className="mt-2">
            <TrustBadge badges={product.seller_id ? product.seller_badges : ["verified"]} size="sm" />
          </div>
        )}
      </div>
    </Link>
  );
}
